import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import Loader from 'apollo-react/components/Loader';
import Paper from 'apollo-react/components/Paper';
import React from 'react';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

import { pages } from '../../Shared/constants';
import AvailableFeatures from './components/AvailableFeatures';
import DisclaimerPage from './components/DisclaimerPage';
import MainContainer from './components/Main/MainContainer';
import NavigationButtons from './components/Navigation/NavigationButtons';
import NoTopicPage from './components/NoTopicPage';
import Pagination from './components/Navigation/Pagination';

export const JourneyBuilderSendOptimizerComponent = ({
  classes,
  steps,
  activityType,
  hasLinkedTopic,
  isLoading,
  isHCOEnabled,
}) => {
  if (isLoading) {
    return <Loader />;
  }

  if (!hasLinkedTopic) {
    return <NoTopicPage />;
  }
  return (
    <Paper className={classes.mainWrapper}>
      <Pagination />
      <Paper className={classes.paper}>
        {isHCOEnabled && (
          <span className={classes.warningMessage}>
            <WarningRoundedIcon className={classes.warningIcon} />
            <FormattedMessage id="journeyBuilder.HCONotSupported" />
          </span>
        )}
        {steps.key === pages.step1.key ? (
          <React.Fragment>
            <AvailableFeatures />
            <MainContainer activityType={activityType} />
          </React.Fragment>
        ) : (
          <DisclaimerPage />
        )}
        {!_.isNil(activityType) && activityType.length > 0 && <NavigationButtons />}
      </Paper>
    </Paper>
  );
};

JourneyBuilderSendOptimizerComponent.displayName = 'JourneyBuilderSendOptimizerComponent';

export default JourneyBuilderSendOptimizerComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/JourneyBuilderSendOptimizerComponent.js